import { TableColumnSortEnum } from 'CorePackage/MainModule/enums/TableColumnSortEnum';
import { ITableColumn } from 'CorePackage/TableModule/interfaces/ITableColumn';

import { DecisionListIdCell } from '../components/DecisionListIdCell';
import { IDecisionListItem } from '../interfaces/IDecisionListItem';

export const initialDecisionTableColumns: Array<ITableColumn<IDecisionListItem>> = [
  {
    id: 'number',
    name: '№ решения',
    sort: TableColumnSortEnum.DESC,
    renderCell: DecisionListIdCell,
    isSelected: true,
  },
  {
    id: 'kindResultDecisionCode',
    name: 'Вид решения',
    sort: TableColumnSortEnum.NONE,
    isSelected: true,
  },
  {
    id: 'kind',
    name: 'Вид мероприятия',
    sort: TableColumnSortEnum.NONE,
    isSelected: true,
  },
  {
    id: 'decisionDate',
    name: 'Дата решения',
    sort: TableColumnSortEnum.NONE,
    isSelected: true,
  },
  {
    id: 'kno',
    name: 'Орган контроля',
    sort: TableColumnSortEnum.NONE,
    isSelected: true,
  },
  {
    id: 'prosecutorOrganization',
    name: 'Орган прокуратуры',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'kindControl',
    name: 'Вид контроля (надзора)',
    sort: TableColumnSortEnum.NONE,
    isSelected: true,
  },
  {
    id: 'status',
    name: 'Статус',
    sort: TableColumnSortEnum.NONE,
    isSelected: true,
  },
  {
    id: 'organizationName',
    name: 'Контролируемое лицо',
    sort: TableColumnSortEnum.NONE,
    isSelected: true,
  },
];
